import { FunctionComponent, PropsWithChildren } from "react";
import { cn } from "../../../utils/cn";

export interface StatisticContainerProps {
  className?: string;
}

/**
 *
 */
export const StatContainer: FunctionComponent<
  PropsWithChildren<StatisticContainerProps>
> = ({ className, children }) => {
  return (
    <div className={cn(className, "flex flex-wrap justify-stretch gap-3")}>
      {children}
    </div>
  );
};

export default StatContainer;
